import Control, { InitOption } from './Control'
import { PlayerStatus } from '../../common/enums'

class DocumentPlayer extends Control {
  option: InitOption = new InitOption()
  playerBox: HTMLElement
  control: Control

  constructor(options: InitOption) {
    super(options)
    this.playerBox = document.querySelector(`#${this.options.id}`) as HTMLElement
    this.playerBox.style.overflow = 'hidden'
    this.createPlayerFrame()
  }

  videoFrame: HTMLIFrameElement

  private createPlayerFrame() {
    this.videoFrame = document.createElement('iframe')
    this.videoFrame.id = `${this.options.id}_frame_container`
    this.playerBox.appendChild(this.videoFrame)
    this.videoFrame.setAttribute('frameborder', '0')
    this.videoFrame.setAttribute('width', '100%')
    this.videoFrame.setAttribute('height', '100%')
    this.videoFrame.src = `/libs/pdfjs/web/viewer.html?file=${encodeURI(this.options.playerConfig.src || '')}`
    this.videoFrame.addEventListener('load', () => {
      if (this.videoFrame.contentDocument) {
        ;(this.videoFrame.contentDocument.documentElement as any).scrollTop = 0
      }
    })
    this.options.id = this.videoFrame.id
    return this.videoFrame
  }

  private bindEvents() {
    // 123
  }

  destroy(): boolean {
    this.videoFrame.remove()
    this.emit(PlayerStatus.destroyed, this)
    this.stop()
    this.elContainer.remove()
    return false
  }
}

export default DocumentPlayer
